/**
 * 农户路由
 */
const MemberRouter = {
  path: 'member',
  name: 'Member',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Member/index')
}
export default MemberRouter
